var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg012FrenchFries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m420.195 199.73-164.27 64.61c26.41 15.14 50.38 31.67 71.63 49.38 32.49 27.09 62.16 62.58 83.19 97.39l29.77-195.16c1.74-11.381-9.547-20.451-20.32-16.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.575 453.77c-41.3-89.7-135.92-155.12-203.12-186.46-41.145-19.188-79.32-31.623-105.104-38.882-11.033-3.106-21.586 6.211-19.858 17.541l38.642 253.291c1.12 7.33 7.42 12.74 14.83 12.74h257.5c7.41 0 13.71-5.41 14.83-12.74 0 0 3.22-43.45 2.28-45.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.195 110.664c0-7.408-6.005-13.414-13.414-13.414h-18.173c-7.408 0-13.414 6.005-13.414 13.414v86.206c16.51 3.82 30.48 7.8 45 12.94v-99.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.195 44.854c0-7.408-6.005-13.414-13.414-13.414h-18.173c-7.408 0-13.414 6.005-13.414 13.414v174.676c12.98 5.42 27.44 11.97 45 20.15v-194.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.195 13.414c0-7.409-6.005-13.414-13.413-13.414h-18.173c-7.408 0-13.414 6.005-13.414 13.414v227.716l45-17.789z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.195 110.664c0-7.408-6.005-13.414-13.414-13.414h-18.173c-7.408 0-13.414 6.005-13.414 13.414v102.846l45-17.7v-85.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.195 169.31v-92.436c0-7.408-6.005-13.414-13.414-13.414h-18.173c-7.408 0-13.414 6.005-13.414 13.414v109.106c39.353-15.476 38.936-15.636 45.001-16.67z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg012FrenchFries);
export default __webpack_public_path__ + "static/media/012-french-fries.148b25a8764296e6adbc5f8fd7b0c7ad.svg";
export { ForwardRef as ReactComponent };